var _a;
import { createSlice } from '@reduxjs/toolkit';
import { DocumentUploadingStatus } from './enums/document-uploading-status';
var initialState = {
    uploading: DocumentUploadingStatus.Uninitialized,
    newDocumentsCount: undefined
};
var machineDocumentSlice = createSlice({
    name: 'machineDocument',
    initialState: initialState,
    reducers: {
        setDocumentUploading: function (state, action) {
            state.uploading = action.payload;
        },
        setNewDocumentCount: function (state, action) {
            state.newDocumentsCount = action.payload;
        }
    }
});
export var setDocumentUploading = (_a = machineDocumentSlice.actions, _a.setDocumentUploading), setNewDocumentCount = _a.setNewDocumentCount;
export var machineDocument = function (state) { return state.machineDocument; };
export default machineDocumentSlice.reducer;
